import React, { useEffect, useState } from "react";
import "./App.css";
import "./index.css";
import AOS from "aos";
import "aos/dist/aos.css";

// Hooks
import { useAudio } from "./hooks/useAudio";

// Components
import Loader from "./components/Loader";
import CursorGlow from "./components/CursorGlow";
import Header from "./components/Header";
import ParticleBackground from "./components/ParticleBackground";
import MouseParticles from "./components/MouseParticles";
import AnimatedBackground from "./components/AnimatedBackground";
import ClickRipple from "./components/ClickRipple";

// Pages
import HeroSection from "./pages/HeroSection";
import ServicesSection from "./pages/ServicesSection";
import IndustriesSection from "./pages/IndustriesSection";
import ProcessSection from "./pages/ProcessSection";
import ProjectsSection from "./pages/ProjectsSection";
import TechnologiesSection from "./pages/TechnologiesSection";
import GamesPortfolioSection from "./pages/GamesPortfolioSection";

import AboutSection from "./pages/AboutSection";
import WhoWeAreSection from "./pages/WhoWeAreSection";
import FAQSection from "./pages/FAQSection";
import InsightsSection from "./pages/InsightsSection";
import ContactSection from "./pages/ContactSection";
import Footer from "./pages/Footer";

function App() {
  const [loading, setLoading] = useState(true);
  const [pos, setPos] = useState({ x: -1000, y: -1000 });
  const [menuOpen, setMenuOpen] = useState(false);

  const { playClick, playError, playMoney } = useAudio();

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 1400);
    
    // Initialize AOS with better settings
    AOS.init({ 
      duration: 800, 
      once: true, 
      easing: "ease-out-cubic",
      offset: 50,
      delay: 0,
      disable: false
    });

    // Refresh AOS after initialization
    setTimeout(() => {
      AOS.refresh();
    }, 100);

    const move = (e) => setPos({ x: e.clientX, y: e.clientY });
    window.addEventListener("mousemove", move);

    return () => {
      clearTimeout(t);
      window.removeEventListener("mousemove", move);
    };
  }, []);

  return (
    <div className="App" onMouseDown={playClick}>
      <AnimatedBackground />
      <ParticleBackground />
      <Loader loading={loading} />
      <CursorGlow pos={pos} />
      <MouseParticles pos={pos} />
      <ClickRipple />
      
      {/* Gaming UI Corners */}
      <div className="game-ui-corner top-left"></div>
      <div className="game-ui-corner top-right"></div>
      <div className="game-ui-corner bottom-left"></div>
      <div className="game-ui-corner bottom-right"></div>
      
      <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <main style={{ position: "relative", zIndex: 2 }}>
        <HeroSection />
        <ServicesSection />
        <ProjectsSection />
        <IndustriesSection />
        <ProcessSection />
        <TechnologiesSection />
        <GamesPortfolioSection />
        <WhoWeAreSection />
        <AboutSection />
        <InsightsSection />
        <FAQSection />
        <ContactSection playError={playError} playMoney={playMoney} />
        <Footer />
      </main>
    </div>
  );
}

export default App;
